import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { OrganizationListComponent } from './organization-list/organization-list.component';
import { OrganizationEditComponent } from './organization-edit/organization-edit.component';
import { AddressValidatorModule } from '../shared/address-validator/address-validator.module';

@NgModule({
  imports: [
    SharedModule,
    AddressValidatorModule
  ],
  declarations: [
    OrganizationListComponent,
    OrganizationEditComponent,
  ],
  exports: [

  ]
})
export class OrganizationModule { }
